import React from 'react'
import EmailPasswordSignin from './EmailPasswordSignin';
import PhonePinSignin from './PhonePinSignin';
import { Link} from 'react-router-dom'
import axios from 'axios';

export default function SignIn(props) {
  const [signInType, setSigninType] = React.useState('email');
  const [signInData, setSignInData] = React.useState({
    email: {
      email: '',
      password: '',
      showPassword: false,
    },
    phone: {
      phone_number: '',
      pin: '',
      showPin: false,
    },
  });

  const handleDataChange = (property, data) => {
    setSignInData({ ...signInData, [property]: data });
  };

  const changeSignInType = () => {
    if(signInType === 'phone') {
      setSigninType('email');
    } else {
      setSigninType('phone');
    }
  }

  const signInTypes = {
    email: <EmailPasswordSignin handleDataChange={handleDataChange}/>,
    phone: <PhonePinSignin handleDataChange={handleDataChange}/>,
  }

  // let isEmpty = () => {
  //   let errors = [];
  //   let values = signInData[signInType];
  //   if(!values){return true}
  //   // console.log(values);
  //   for(let key in values) {
  //     if(values[key].length < 1) {
  //       errors.push(true);
  //     }
  //   }
  //   console.log(errors);
  //   return errors.includes(true) ? true : false;
  // }

  let errorStyle = (id, property, style) => {document.getElementById(`${id}`).style[property] = style}

  let errorTarget = (id, value) => {
      let errors = false;
      // let errorStyle = (style) => {document.getElementById(`${id}-container`).style.borderBottom = style}
      if(value.length < 1){
        errorStyle(`${id}-container`, 'border', '1px solid #ef4b4b')
        errors = true;
      } else if (id === 'email') {
        if(!emailValidation(value)) {
          errorStyle(`${id}-container`, 'border', '1px solid #5e76e8')
          // errorStyle('3px solid #5e76e8')
          errors = true;
        } else {
          errorStyle(`${id}-container`, 'border', '')
          // errorStyle('');
        }
      } else {
        errorStyle(`${id}-container`, 'border', '')
        // errorStyle('');
      }
      return errors;
  }

  const emailValidation = (string) => {
      let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      
      if(string.match(mailFormat)){
          return true;
      } else {
          return false;
      }
  }

  let infoProps = {phone:['phone_number', 'pin'], email:['email', 'password']};
  let hasErrors = () => {
    let errors = [];
    let keys = infoProps[signInType];
    for(let i = 0; i < keys.length; i++) {
      let id = keys[i];
      let value = signInData[signInType][id];
      errors.push(errorTarget(id, value));
    }
    return errors.includes(true) ? true : false;
  }

  const [signInError, setSignInError] = React.useState(false);

  const signInUser = () => {
    let tok =  btoa(`${props.unicycle}:${props.pencil}`);
    let currSignInData = signInData[signInType];
    let phoneNumber = signInType === 'phone' ? currSignInData.phone_number.includes('-') ? currSignInData.phone_number.split('-').join('') : currSignInData.phone_number : '';
    if(hasErrors()) {return}
    let data = JSON.stringify({
      "typeEmailOrPhone": signInType === 'phone' ? 'mobile' : 'email',
      "orgId": props.orgId,
      "email": currSignInData.email ? currSignInData.email : '',
      "mobile": currSignInData.phone_number ? phoneNumber : '',
      "pin": currSignInData.pin ? currSignInData.pin : '',
      "password": currSignInData.password ? currSignInData.password : '',
    })

    axios.post('https://api.churchpad.com/p/login/', data, {
        headers: { 
            'Authorization' : `Basic ${tok}`,
            'Content-Type': 'application/json',
        },
    }).then(res => {
      if(res.data.responseMessage === 'success') {
          window.location = res.data.responseData.successUrl;
        } else {
          setSignInError(res.data.responseMessage)
        }
        console.log(res)
    }).catch(err => {
        console.log(err);
    })
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  let forgotType = signInType === 'email' ? 'password' : 'pin'

  return (
    <main className="authentication signup">
      <header>
        <span className="icon" style={{backgroundColor: props.colors.secondary}}>
          <i className="las la-user"></i>
        </span>
        <h3>{capitalizeFirstLetter(signInType)} Sign In</h3>
      </header>
      {
        signInTypes[signInType]
      }
      <div className="selectSignInType">
        <div className="signInType" onClick={changeSignInType}>
            <button className="waves-effect"><h4>Sign in with my {signInType === 'email' ? "phone number" : "email"}</h4></button>
        </div>

        <div className="forgotPassword">
          <Link to={`/cp/forgot-${forgotType}`}>
            <button className="waves-effect"><h4>Forgot {forgotType}?</h4></button>
          </Link>
        </div>
      </div>

      <div className="submit">
        <button className="signIn-button submit-btn waves-effect" style={{backgroundColor: props.colors.secondary}} onClick={signInUser}> <h4>Sign in</h4> </button>
      </div>

      <Link to={'/cp/signup'}>
        <div className="noAccount">
          <button className='waves-effect'>Don't have an account? Sign Up</button>
        </div>
      </Link>

      <div className="errorMessage">
        <h4 className="red-text">
          { signInError ? 
            <>
            <span className="red" style={{display: 'flex', width: '30px', margin: 'auto', height: '30px', justifyContent: 'center', alignItems: 'center', borderRadius: '100%'}}><i className="las la-exclamation white-text"></i></span> 
            <br/>
            {signInError}
            </> : null
          }
        </h4>
      </div>
    </main>
  )
}
